/**
 * Which saved feed the canvas is editing, for the shapes inside it.
 *
 * `CanvasEditor` already takes a `feedId` and hands it to the side panels, but a shape could not
 * reach it — and a shape needs it for anything that lives on the FEED rather than in the manifest.
 * The gym's enrolment is exactly that: `algorithms.settings`, written through
 * `/algo_settings/set_setting/{id}` and keyed by the numeric id.
 *
 * Its own file rather than an export from `CanvasEditor.tsx` because `CanvasEditor` imports the
 * shapes; a shape importing back from it is a cycle. Same reason `InFrontOfCanvasPortal` is its own
 * file.
 *
 * `undefined` is the honest default and means "this canvas is not editing a saved feed" — the
 * template preview, the custom-node diff editor, a story. Anything feed-scoped must render as
 * absent there, not guess an id.
 */

import { createContext } from "react";

export const GrazeFeedIdContext = createContext<number | undefined>(undefined);
